import { t } from 'i18next';

const getCaptions = ({ currentCount, allCount }) => ({
  selectCaptions: {
    title: t('Select a website template'),
    subtitle: t(
      "Unsure which template to pick? Don't worry, you can easily switch templates at any time without losing any of your content."
    ),
    paginationLabel: t('Viewing {currentCount} out of {allCount}', {
      currentCount: `<span style="color: var(--primary-800)">${currentCount}</span>`,
      allCount: `<span style="color: var(--primary-800)">${allCount}</span>`,
    }),

    recommendedTemplatesLabel: t('Recommended templates'),
    allTemplatesLabel: t('All templates'),
    loadMoreButton: t('Load more templates'),
  },
  resetCaptions: {
    title: t('Reset your website'),
    subtitle: t(
      'Complete the website reset by selecting a new template. Please proceed with this step carefully. You cannot recover your site after the reset.'
    ),
    paginationLabel: t('Viewing {currentCount} out of {allCount}', {
      currentCount: `<span style="color: var(--primary-800)">${currentCount}</span>`,
      allCount: `<span style="color: var(--primary-800)">${allCount}</span>`,
    }),

    recommendedTemplatesLabel: t('Recommended templates'),
    allTemplatesLabel: t('All templates'),
    loadMoreButton: t('Load more templates'),
  },
  switchCaptions: {
    title: t('Switch website template'),
    subtitle: t(
      "Choose the new template from our rich collection. Don't worry, your content will not be changed."
    ),
    paginationLabel: t('Viewing {currentCount} out of {allCount}', {
      currentCount: `<span style="color: var(--primary-800)">${currentCount}</span>`,
      allCount: `<span style="color: var(--primary-800)">${allCount}</span>`,
    }),

    recommendedTemplatesLabel: t('Recommended templates'),
    allTemplatesLabel: t('All templates'),
    loadMoreButton: t('Load more templates'),
  },
});

const getGalleryCaptions = ({ siteIdToSwitch, siteIdToRecreate, currentCount, allCount }) => {
  const { selectCaptions, resetCaptions, switchCaptions } = getCaptions({ currentCount, allCount });

  if (siteIdToRecreate) {
    return resetCaptions;
  }

  if (siteIdToSwitch) {
    return switchCaptions;
  }

  return selectCaptions;
};

export default getGalleryCaptions;
